<script setup>
import { ref, watch} from 'vue'
import { useRouter, RouterLink } from 'vue-router'
import { event } from 'vue-gtag'

const props = defineProps({
	indicator: {
		type: Object,
		required: true
	}	
})

//componenet methods exposed to parent
defineExpose({
	setupMsg,
})

//reactive field proxies
const selections = ref('')

//local variables
const router = useRouter()

function showCountactUs() {
	router.push({ path: '/about/contact' })
}

function setupMsg(indicator) {
	//if(value) {

		let str = ""
		indicator.columns.items.forEach(i => {
			if(i.valueFlag == 0 && i.categoryLabelFlag == 1) {
				if(i.appliedValues && i.appliedValues.length > 0) {
					let selected = i.appliedValues.filter(x => x.selected)
					if(i.appliedValues.length > selected.length) {
						str += i.columnName + ": "
						selected.forEach((x,i) => {
							str += (i>0?", ":'') + x.name
						})
						str += "; "
					}
				}
			}
		})
		selections.value = str
	//}
	event('nodata_warning', { 'indicator' : indicator.indicatorName, 'filters' : selections.value.replaceAll('; ','|') })
}
</script>

<template>
	<div class="msg-wrapper">
		<div class="msg-header">
			{{props.indicator.indicatorName}}
		</div>	
		<div class="msg-container warning">
			<div class="msg-content">
				<span class="warning">
					<i class="fa-solid fa-triangle-exclamation"></i>
				</span>										
				<span class="warning">No Data Available</span>
				<span>No Data Available for this combination of selections. Please update your selections in settings.</span>
				<div class="msg-footer">
					Selections made:  {{selections}}
				</div>	
			</div>
			<div class="msg-controls">
				<button @click="showCountactUs" class="btn-tertiary">
					Contact us
				</button>				
			</div>
		</div>
	</div>
</template>
   
<style scoped>
	.msg-wrapper {
		min-height: 25rem;
	}
	.msg-header {
		color: var(--text-Header, #171717);
		text-align: center;
		/* Regular/H6 */
		font-family: var(--font-family-Title, Roboto);
		font-size: var(--font-size-H6, 1.25rem);
		font-style: normal;
		font-weight: 400;
		width: 100%;
		padding-bottom: var(--spacing-3xl, 2.5rem);
	}
	.msg-container {
		min-width: 22.75rem;
		line-height: var(--font-line-height-Base, 24px); /* 150% */
		padding: var(--spacing-md, 8px) var(--spacing-lg, 16px);
		border-radius: var(--radius-lg, 8px);
		border: 1px solid var(--border-color-input-Border, #A9B7C7);
		/* background: var(--surfaces-surface-tertiary, #FAFAFA); */
		box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.15);		
	}

	.msg-content {
		font-size: var(--font-size-Base);
		font-family: var(--font-family-Title);
		color: var(--brand-color-MedGrey);
	}

	.btn-tertiary {
		min-height: unset;
		height: unset;
		padding: 0;
		font-weight: 500;
	}

	/* warning */
	.msg-container.warning {
		border: 1.5px solid var(--brand-color-BurntYellow);
		color: var(--brand-color-BurntYellow);
	}

	.msg-content .warning {
		color: var(--brand-color-BurntYellow);
		padding-right: .75rem;
	}

	.msg-footer, .msg-controls {
		margin-top: 1.5rem;
	}
	.btn-tertiary.warning {
		color: var(--brand-color-BurntYellow); 
	}	
</style>